import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Confirmation = /*#__PURE__*/function () {
  function Confirmation(config, axios) {
    _classCallCheck(this, Confirmation);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Confirmation, [{
    key: "processPaymentOptionDetails",
    value: function processPaymentOptionDetails(orderDetails) {
      var _orderDetails$order, _orderDetails$order$p;

      var paymentDetails = [];
      (_orderDetails$order = orderDetails.order) === null || _orderDetails$order === void 0 ? void 0 : (_orderDetails$order$p = _orderDetails$order.paymentGroup) === null || _orderDetails$order$p === void 0 ? void 0 : _orderDetails$order$p.forEach(function (paymentOption) {
        var _ref;

        paymentDetails.push({
          creditCardType: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.creditCardType,
          amount: (_ref = (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.amount) + (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.tipAmount) + (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paygrpTipAmount)) !== null && _ref !== void 0 ? _ref : 0,
          paygrpTipAmount: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paygrpTipAmount,
          tipAmount: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.tipAmount,
          paymentMethod: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paymentMethod,
          paymentCardToken: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paymentCardToken,
          giftCardNumber: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.giftCardNumber,
          giftCardType: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.giftCardType,
          walletType: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.walletType
        });
      });
      orderDetails.order.paymentDetails = paymentDetails;
    }
  }, {
    key: "getLastOrder",
    value: function () {
      var _getLastOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _response$data;

        var response, _response$data2, _response$data2$succe, _response$data2$succe2, _response$data2$succe3, _response$data3;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.LAST_ORDER_DETAILS);

              case 2:
                response = _context.sent;

                if (!((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.successResponse)) {
                  _context.next = 7;
                  break;
                }

                if (((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$succe = _response$data2.successResponse) === null || _response$data2$succe === void 0 ? void 0 : (_response$data2$succe2 = _response$data2$succe.order) === null || _response$data2$succe2 === void 0 ? void 0 : (_response$data2$succe3 = _response$data2$succe2.specialInstruction) === null || _response$data2$succe3 === void 0 ? void 0 : _response$data2$succe3.instructionText) === "null") {
                  response.data.successResponse.order.specialInstruction.instructionText = null;
                }

                this.processPaymentOptionDetails(response.data.successResponse);
                return _context.abrupt("return", (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.successResponse);

              case 7:
                return _context.abrupt("return", null);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLastOrder() {
        return _getLastOrder.apply(this, arguments);
      }

      return getLastOrder;
    }()
  }, {
    key: "setJoinEClub",
    value: function () {
      var _setJoinEClub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(email, signupSource) {
        var secondarySubscriptions,
            eClubStep,
            response,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                secondarySubscriptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
                eClubStep = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : "1";
                _context2.prev = 2;
                _context2.next = 5;
                return this.axios.post(this.config.postfix.JOIN_ECLUB, {
                  email: email,
                  signupSource: signupSource,
                  eClubStep: eClubStep,
                  secondarySubscriptions: secondarySubscriptions
                });

              case 5:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                console.error(_context2.t0);
                return _context2.abrupt("return");

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 9]]);
      }));

      function setJoinEClub(_x, _x2) {
        return _setJoinEClub.apply(this, arguments);
      }

      return setJoinEClub;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
        var _response$data4, response, _error$response;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.axios.post(this.config.postfix.UPDATE_PROFILE_INFO, _objectSpread({}, args));

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", {
                  success: true,
                  data: (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.successResponse
                });

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {
                  success: false,
                  data: _context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$response = _context3.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function createAccount(_x3) {
        return _createAccount.apply(this, arguments);
      }

      return createAccount;
    }()
  }]);

  return Confirmation;
}();

export { Confirmation as default };